import { Facebook, Instagram } from "lucide-react";
import { NavLink } from "react-router-dom";

function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-800 text-white pt-10 mt-20">
      <div className="max-w-6xl mx-auto px-6 grid grid-cols-1 md:grid-cols-5 gap-10 text-center md:text-left">
        {/* Brand Info */}
        <div className="md:col-span-2">
          {/* Logo */}
          <NavLink to="/" className="inline-block">
            <img
              src="/images/logos/Exudee-logo-white.svg"
              alt="Exudee Hampers Logo White"
              className="h-14 w-auto"
            />
          </NavLink>
          <p className="text-sm text-gray-300">
            Exudee Hampers offers thoughtfully curated <br />
            gift hampers with flowers and accessories for <br />
            every occasion. We provide personalized gifting <br />
            options with same-day delivery across Dallas <br />
            and surrounding areas - elegant, meaningful, <br />
            and right on time.
          </p>
        </div>

        {/* Explore */}
        <div className="md:col-span-1">
          <h5 className="font-bold mb-2">Explore</h5>
          <ul className="text-sm space-y-1">
            <li><a href="/" className="hover:underline">Home</a></li>
            <li><a href="/shop" className="hover:underline">Shop All</a></li>
            <li><a href="/build" className="hover:underline">Build Your Hamper</a></li>
            <li><a href="/flowers" className="hover:underline">Flowers</a></li>
            <li><a href="/accessories" className="hover:underline">Accessories</a></li>
            <li><a href="/vip" className="hover:underline">VIP Collections</a></li>
            <li><a href="/cart" className="hover:underline">Cart</a></li>
          </ul>
        </div>

        {/* Resources */}
        <div className="md:col-span-1">
          <h5 className="font-bold mb-2">Resources</h5>
          <ul className="text-sm space-y-1">
            <li><a href="/about" className="hover:underline">About Us</a></li>
            <li><a href="/contact" className="hover:underline">Contact Us</a></li>
            <li><a href="/faqs" className="hover:underline">FAQs</a></li>
            <li><a href="/blog" className="hover:underline">Blog</a></li>
            <li><a href="/policies" className="hover:underline">Our Policies</a></li>
            <li><a href="/terms" className="hover:underline">Terms of Agreement</a></li>
          </ul>
        </div>

        {/* Contact + Socials */}
        <div className="md:col-span-1 text-center md:text-left md:min-w-[180px]">
          <h5 className="font-bold mb-2">Contact Us</h5>
          <p className="text-sm mb-1 whitespace-nowrap">
            <span className="font-semibold">Email 1:</span> info@exudeehampers.com
          </p>
          <p className="text-sm mb-1 whitespace-nowrap">
            <span className="font-semibold">Email 2:</span> support@exudeehampers.com
          </p>
          <p className="text-sm mb-4 whitespace-nowrap">
            <span className="font-semibold">Phone:</span> +1 (469) 590-5754
          </p>

          <div className="flex gap-3 justify-center md:justify-start mt-4">
            {/* Social Icons */}
            <a
              href="https://web.facebook.com/profile.php?id=61579974249431"
              target="_blank"
              rel="noreferrer"
              className="w-10 h-10 flex items-center justify-center rounded-full border border-white hover:bg-white/20 transition"
            >
              <Facebook className="w-5 h-5 text-white stroke-[1.5]" />
            </a>
            <a
              href="https://www.instagram.com/exudeehampers/"
              target="_blank"
              rel="noreferrer"
              className="w-10 h-10 flex items-center justify-center rounded-full border border-white hover:bg-white/20 transition"
            >
              <Instagram className="w-5 h-5 text-white stroke-[1.5]" />
            </a>
            <a
              href="https://x.com/exudeehampers"
              target="_blank"
              rel="noopener noreferrer"
              className="w-10 h-10 flex items-center justify-center rounded-full border border-white hover:bg-white/20 transition"
            >
              <img src="/images/icons/x-icon-white.png" alt="X.com" className="w-5 h-5" />
            </a>
            <a
              href="https://wa.me/12148150503"
              target="_blank"
              rel="noopener noreferrer"
              className="w-10 h-10 flex items-center justify-center rounded-full border border-white hover:bg-white/20 transition"
            >
              <img src="/images/icons/whatsapp-icon-white.png" alt="WhatsApp" className="w-5 h-5" />
            </a>
          </div>
        </div>

      </div>

      {/* Full-width horizontal line */}
      <div className="border-t border-gray-700 mt-12" />

      {/* Bottom Row */}
      <div className="flex flex-col md:flex-row justify-between items-center px-6 py-4 text-sm text-gray-400 max-w-6xl mx-auto">
        <p>&copy; {currentYear} Exudee Hampers. All rights reserved.</p>
        <div className="flex gap-4 mt-2 md:mt-0">
          <a href="/policies" className="hover:underline">Our Policies</a>
          <a href="/privacy-policy" className="hover:underline">Privacy Policy</a>
          <a href="/cookie-policy" className="hover:underline">Cookie Policy</a>
          <a href="/terms" className="hover:underline">Terms of Agreement</a>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
